import React, { useRef, useState } from "react";
import "../css/FieldRenderer.css";
import axios from "axios";

// const CLOUDINARY_CLOUD = "dnriybfwk";      
// const CLOUDINARY_PRESET = "ofak_assets";   


export default function FieldRenderer({ field, onChange }) {
  const value = field.value ?? "";
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
    const imageRef = useRef(null);     // ✅ separate refs
  const videoRef = useRef(null);
  const fileRef = useRef(null);

  const uploadToS3 = async (file) => {
    setUploading(true);
    setUploadError("");
    try {
      //get signed url

      const { data } = await axios.post(
        "/api/assets/upload-url",
        {
           fileName: file.name,
           contentType: file.type
        }
      );

      const { uploadUrl, fileUrl } = data.data;

      //upload directly to S3

      await axios.put(
        uploadUrl, 
        file,
        {
          headers: {
            "Content-Type": file.type,
          },
        }
      );

      //save cdn url into form state
      onChange(field.key, fileUrl);
    } catch(error) {
        console.error(error);
        setUploadError(
          error?.response?.data?.message || "Upload failed"
        );
    } finally {
      setUploading(false);
    }
  };

  // const uploadToCloudinary = async (file) => {
  //   setUploading(true);
  //   setUploadError("");
  //   try {
  //     const form = new FormData();
  //     form.append("file", file);
  //     form.append("upload_preset", CLOUDINARY_PRESET);

  //     const res = await fetch(
  //       `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD}/auto/upload`,
  //       { method: "POST", body: form }
  //     );
  //     const data = await res.json();
  //     if (data.secure_url) {
  //       onChange(field.key, data.secure_url);
  //     } else {
  //       setUploadError("Upload failed. Check your preset/cloud name.");
  //     }
  //   } catch (e) {
  //     setUploadError("Upload error. Try again.");
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  // ✅ CONDITION HANDLING
if (field.condition) {
  const { field: depField, value: depValue } = field.condition;
  const parentValues = field.parentValues || {};

  // ❗ If type not selected → hide everything except type
  if (!parentValues[depField]) {
    return null;
  }

  if (parentValues[depField] !== depValue) {
    return null;
  }
}

  return (
    <div className="fieldContainer">

      {/* ── LABEL ── */}
      <label className="fieldLabel">
        {field.label || field.key}
        {field.maxLength && (
          <span className="charCount">{String(value).length} / {field.maxLength}</span>
        )}
      </label>

      {/* ── TEXT ── */}
      {field.type === "text" && (
        <div className="inputRow">
          <input
            type="text"
            className="fieldInput"
            value={value}
            maxLength={field.maxLength}
            placeholder={`Enter ${field.label || field.key}…`}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
          {field.taggable && (
            <select
              className="tagSelect"
              value={field.tagValue || "h2"}
              onChange={(e) => onChange(field.key + "_tag", e.target.value)}
            >
              {["h1", "h2", "h3", "h4", "h5", "h6"].map(tag => (
                <option key={tag} value={tag}>{tag}</option>
              ))}
            </select>
          )}
        </div>
      )}

      {/* ── TEXTAREA ── */}
      {field.type === "textarea" && (
        <div className="inputRow">
        <textarea
          className="fieldTextarea"
          value={value}
          maxLength={field.maxLength}
          placeholder={`Enter ${field.label || field.key}…`}
          onChange={(e) => onChange(field.key, e.target.value)}
        />
          {field.taggable && (
      <select
        className="tagSelect"
        value={field.tagValue || "p"}
        onChange={(e) => onChange(field.key + "_tag", e.target.value)}
      >
        {["h1", "h2", "h3", "h4", "h5", "h6"].map(tag => (
          <option key={tag} value={tag}>{tag}</option>
        ))}
      </select>
    )}
        </div>
      )}

      {/* ── IMAGE ── */}
      {field.type === "image" && (
        <div className="mediaField">
          {value ? (
            <div className="mediaPreviewWrapper">
              <img src={value} alt="preview" className="mediaPreview" />
              <div className="mediaOverlay">
                <button className="mediaChangeBtn" onClick={() => imageRef.current?.click()}>
                  Change Image
                </button>
                <button className="mediaRemoveBtn" onClick={() => onChange(field.key, "")}>
                  Remove
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`mediaDropzone ${uploading ? "uploading" : ""}`}
              onClick={() => imageRef.current?.click()}
            >
              {uploading ? (
                <div className="uploadSpinner">
                  <span className="spinnerRing" />
                  <span>Uploading…</span>
                </div>
              ) : (
                <>
                  <div className="dropzoneIcon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <rect x="3" y="3" width="18" height="18" rx="3"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <path d="M21 15l-5-5L5 21"/>
                    </svg>
                  </div>
                  <p className="dropzoneTitle">Click to upload image</p>
                  <p className="dropzoneHint">PNG, JPG, WEBP · Max 10MB</p>
                </>
              )}
            </div>
          )}
          <input
            ref={imageRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) uploadToS3(file);
              e.target.value = "";
            }}
          />
          {uploadError && <p className="uploadError">{uploadError}</p>}
          {value && (
            <p className="mediaUrl" title={value}>
              <span className="mediaUrlLabel">URL</span>
              {value}
            </p>
          )}
        </div>
      )}

      {/* ── VIDEO ── */}
      {field.type === "video" && (
        <div className="mediaField">
          {value ? (
            <div className="mediaPreviewWrapper">
              <video src={value} controls className="mediaPreview videoPreview" />
              <div className="mediaOverlay">
                <button className="mediaChangeBtn" onClick={() => videoRef.current?.click()}>
                  Change Video
                </button>
                <button className="mediaRemoveBtn" onClick={() => onChange(field.key, "")}>
                  Remove
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`mediaDropzone ${uploading ? "uploading" : ""}`}
              onClick={() => videoRef.current?.click()}
            >
              {uploading ? (
                <div className="uploadSpinner">
                  <span className="spinnerRing" />
                  <span>Uploading…</span>
                </div>
              ) : (
                <>
                  <div className="dropzoneIcon videoIcon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <rect x="2" y="4" width="20" height="16" rx="3"/>
                      <path d="M10 9l5 3-5 3V9z" fill="currentColor" stroke="none"/>
                    </svg>
                  </div>
                  <p className="dropzoneTitle">Click to upload video</p>
                  <p className="dropzoneHint">MP4, MOV, WEBM · Max 100MB</p>
                </>
              )}
            </div>
          )}
          <input
            ref={videoRef}
            type="file"
            accept="video/*"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) uploadToS3(file);
              e.target.value = "";
            }}
          />
          {uploadError && <p className="uploadError">{uploadError}</p>}
          {value && (
            <p className="mediaUrl" title={value}>
              <span className="mediaUrlLabel">URL</span>
              {value}
            </p>
          )}
        </div>
      )}

      {/* ── COLOR PICKER ── */}
{field.type === "color" && (
  <div className="colorField">
    <input
      type="color"
      className="colorInput"
      value={value || "#000000"}
      onChange={(e) => onChange(field.key, e.target.value)}
    />

    <input
      type="text"
      className="colorHexInput"
      value={value || ""}
      placeholder="#000000"
      onChange={(e) => onChange(field.key, e.target.value)}
    />
  </div>
)}

{/* ── FILE (PDF / DOC / ETC) ── */}
{field.type === "file" && (
  <div className="mediaField">

    {value ? (
      <div className="filePreview">
        <div className="fileInfo">
          📄 File uploaded
        </div>

        <div className="fileActions">
          <button onClick={() => fileRef.current?.click()}>
            Replace
          </button>
          <button onClick={() => onChange(field.key, "")}>
            Remove
          </button>
        </div>
      </div>
    ) : (
      <div
        className={`mediaDropzone ${uploading ? "uploading" : ""}`}
        onClick={() => fileRef.current?.click()}
      >
        {uploading ? (
          <div className="uploadSpinner">
            <span className="spinnerRing" />
            <span>Uploading…</span>
          </div>
        ) : (
          <>
            <p className="dropzoneTitle">Upload file</p>
            <p className="dropzoneHint">PDF, DOCX, etc</p>
          </>
        )}
      </div>
    )}

    <input
      ref={fileRef}
      type="file"
      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx"
      style={{ display: "none" }}
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (file) uploadToS3(file);
        e.target.value = "";
      }}
    />

    {value && (
      <p className="mediaUrl" title={value}>
        <span className="mediaUrlLabel">URL</span>
        {value}
      </p>
    )}

  </div>
)}

{/* ── SELECT ── */}
{field.type === "select" && (
  <select
    className="fieldInput"
    value={value}
    onChange={(e) => onChange(field.key, e.target.value)}
  >
    <option value="">Select {field.label}</option>
    {field.options?.map(opt => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
)}

    </div>
  );
}

